import React from 'react';
import { Badge } from '../ui';

// SQL dates arrive as UTC midnight ISO strings; format in UTC so they don't shift a day.
export const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' })
    : '—';

const money = (n) => `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

export const formatCompensation = (row) => {
  if (row.Exact != null) return money(row.Exact);
  if (row.SalaryLow != null || row.SalaryHigh != null) {
    if (row.SalaryHigh == null) return `${money(row.SalaryLow)}+`;
    return `${money(row.SalaryLow || 0)} – ${money(row.SalaryHigh)}`;
  }
  return row.Amount || '—';
};

export const hasCompensation = (rows) =>
  rows.some((r) => r.Exact != null || r.SalaryLow != null || r.SalaryHigh != null || r.Amount);

export const lobbyistName = (l) =>
  [l.LobbyistFirstName, l.LobbyistMiddleName, l.LobbyistLastName].filter(Boolean).join(' ') ||
  l.LobbyistFullName ||
  'Unnamed lobbyist';

export const StatusBadge = ({ status }) => {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const s = status.toLowerCase();
  const variant = s === 'active' ? 'success' : s === 'ended' || s.startsWith('term') ? 'danger' : 'secondary';
  return <Badge variant={variant}>{status}</Badge>;
};

// Distinct years present in a set of engagements, newest first.
export const yearsOf = (rows) => [...new Set(rows.map((r) => r.Year).filter(Boolean))].sort((a, b) => b - a);
